import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import SteamTopPlaySchoolLeaderboard from '../views/steminpe/SteamTopPlaySchoolLeaderboard';
import SteamTopPlayStudentLeaderboard   from '../views/steminpe/SteamTopPlayStudentLeaderboard';
import SteamTopParticipantSportLeaderboard from '../views/steminpe/SteamTopParticipantSportLeaderboard';

const SteminpeRoute = {
    path: '/steminpe',
    // element: <HomeLayout />,
    children: [
        {
            path: 'leaderboard/school-play-duration',
            element: <SteamTopPlaySchoolLeaderboard />
        },
        {
            path: 'leaderboard/student-play-duration/:orgId/:skillCode',
            element: <SteamTopPlayStudentLeaderboard />
        },
        {
            path: 'leaderboard/participant-sport',
            element: <SteamTopParticipantSportLeaderboard />    
        }
    ]
};

export default SteminpeRoute;